<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    
    <section>
      <ValidationObserver 
        ref="form">
        <v-form>
          <v-row class="lainnya-page-row">
            <v-col
              cols="12"
              md="10"
              lg="8"
              class="py-0">
              <v-card
                class="lainnya-card"
                elevation="0">
                <v-card-title class="lainnya-card__title pb-0">
                  Lainnya
                </v-card-title>
                <!-- <v-card-subtitle class="lainnya-card__subtitle pt-1 pb-0">
                  Abdi Dalem — data tambahan
                </v-card-subtitle> -->

                <v-card-text class="lainnya-card__body">
                  <v-card class="mb-4 pa-4" outlined>
                    <div class="lainnya-section-head mb-1">
                      Bantuan Penghasilan
                    </div>

                    <div class="lainnya-field-block">
                      <ValidationProvider
                        name="is_terima_danais"
                        rules="required"
                        v-slot="{ errors }">
                        <label class="lainnya-field-label">
                          Bantuan Penghasilan Abdi Dalem / Danais
                        </label>
                        <v-radio-group
                          v-model="form.is_terima_danais"
                          class="lainnya-radio-group mt-1"
                          row
                          hide-details
                          :error-messages="errors">
                          <v-radio
                            :color="set_color"
                            label="Ya"
                            :value="1"/>
                          <v-radio
                            :color="set_color"
                            label="Tidak"
                            :value="0"/>
                        </v-radio-group>
                      </ValidationProvider>
                    </div>

                    <template v-if="isYes(form.is_terima_danais)">
                      <div class="lainnya-field-block ml-3">
                        <v-menu
                          ref="tgl_awal_terima_danais"
                          min-width="290px"
                          max-width="290px"
                          transition="scale-transition"
                          offset-y
                          :nudge-right="40"
                          :close-on-content-click="false"
                          v-model="picker.tgl_awal_terima_danais">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider
                              name="tgl_awal_terima_danais"
                              rules="required"
                              v-slot="{ errors, valid }">
                              <label class="lainnya-field-label">
                                Tanggal Awal Terima BPAD / Danais
                              </label>
                              <v-text-field
                                class="lainnya-input mt-1"
                                readonly
                                filled
                                rounded
                                hide-details
                                dense
                                style="border-radius: 10px"
                                :color="set_color"
                                placeholder="Pilih tanggal"
                                clearable
                                append-icon="mdi-calendar"
                                @click:clear="form.tgl_awal_terima_danais = ''"
                                v-model="form.tgl_awal_terima_danais"
                                v-on="on"
                                v-bind="attrs"
                                :success="!!form.tgl_awal_terima_danais && valid"
                                :error-messages="errors">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      Tanggal Awal Terima BPAD / Danais {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  <div v-if="form.tgl_awal_terima_danais !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker
                            :color="set_color"
                            v-model="form.tgl_awal_terima_danais"
                            @input="picker.tgl_awal_terima_danais = false"/>
                        </v-menu>
                      </div>

                      <div class="lainnya-field-block ml-3">
                        <ValidationProvider
                          name="norek_danais"
                          rules="required"
                          v-slot="{ errors, valid }">
                          <label class="lainnya-field-label">
                            No. Rekening BPD
                          </label>
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="lainnya-input mt-1"
                            filled
                            rounded
                            dense
                            style="border-radius: 10px"
                            :color="set_color"
                            placeholder="Hanya angka"
                            clearable
                            inputmode="numeric"
                            autocomplete="off"
                            hide-details
                            @click:clear="form.norek_danais = ''"
                            @input="form.norek_danais = sanitizeDigitsOnly(form.norek_danais)"
                            @keypress="onDigitsKeypress"
                            v-model="form.norek_danais"
                            :success="!!form.norek_danais && valid"
                            :error-messages="errors"
                            required>
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  No. Rekening BPD {{ errors[0] }}
                                </v-tooltip>
                              </div>
                              <div v-if="form.norek_danais !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </div>
                    </template>
                  </v-card>

                  <v-card class="mb-4 pa-4" outlined>
                    <div class="lainnya-section-head mb-1">
                      Koperasi
                    </div>


                    <div class="lainnya-field-block">
                      <ValidationProvider
                        name="is_anggota_koperasi"
                        rules="required"
                        v-slot="{ errors }">
                        <label class="lainnya-field-label">
                          Anggota Koperasi
                        </label>
                        <v-radio-group
                          v-model="form.is_anggota_koperasi"
                          class="lainnya-radio-group mt-1"
                          row
                          hide-details
                          :error-messages="errors">
                          <v-radio
                            :color="set_color"
                            label="Ya"
                            :value="1"/>
                          <v-radio
                            :color="set_color"
                            label="Tidak"
                            :value="0"/>
                        </v-radio-group>
                      </ValidationProvider>
                    </div>

                    <div
                      v-if="isYes(form.is_anggota_koperasi)"
                      class="lainnya-field-block ml-3">
                      <v-menu
                        ref="kop_join_date"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.kop_join_date">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="kop_join_date"
                            v-slot="{ errors, valid }">
                            <label class="lainnya-field-label">
                              Tanggal Bergabung Koperasi
                            </label>
                            <v-text-field
                              class="lainnya-input mt-1"
                              readonly
                              filled
                              rounded
                              dense
                              style="border-radius: 10px"
                              :color="set_color"
                              placeholder="Pilih tanggal"
                              clearable
                              append-icon="mdi-calendar"
                              hide-details
                              @click:clear="form.kop_join_date = ''"
                              v-model="form.kop_join_date"
                              v-on="on"
                              v-bind="attrs"
                              :success="!!form.kop_join_date && valid"
                              :error-messages="errors">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal Bergabung Koperasi {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                <div v-if="form.kop_join_date !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker
                          :color="set_color"
                          v-model="form.kop_join_date"
                          @input="picker.kop_join_date = false"/>
                      </v-menu>
                    </div>
                  </v-card> 

                  <v-card class="mb-4 pa-4" outlined>
                    <div class="lainnya-section-head mb-1">
                      Keikutsertaan BPJS
                    </div>
                    <div class="ml-3 mb-4">
                      <div class="lainnya-field-block">
                        <ValidationProvider
                          name="is_bpjs_ketenagakerjaan"
                          rules="required"
                          v-slot="{ errors }">
                          <label class="lainnya-field-label">
                            a. Ketenagakerjaan
                          </label>
                          <v-radio-group
                            v-model="form.is_bpjs_ketenagakerjaan"
                            class="lainnya-radio-group mt-1"
                            row
                            hide-details
                            :error-messages="errors">
                            <v-radio
                              :color="set_color"
                              label="Ya"
                              :value="1"/>
                            <v-radio
                              :color="set_color"
                              label="Tidak"
                              :value="0"/>
                          </v-radio-group>
                        </ValidationProvider>
                      </div>
    
                      <template v-if="isYes(form.is_bpjs_ketenagakerjaan)">
                        <div class="lainnya-field-block lainnya-nested ml-3">
                          <ValidationProvider
                            name="is_bpjs_ketenagakerjaan_number"
                            rules="required"
                            v-slot="{ errors, valid }">
                            <label class="lainnya-field-label">
                              Nomor Peserta
                            </label>
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="lainnya-input mt-1"
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Nomor peserta"
                              clearable
                              type="text"
                              inputmode="numeric"
                              style="border-radius: 10px"
                              hide-details
                              @click:clear="form.is_bpjs_ketenagakerjaan_number = ''"
                              @keypress="onDigitsKeypress"
                              @input="form.is_bpjs_ketenagakerjaan_number = sanitizeDigitsOnly(form.is_bpjs_ketenagakerjaan_number)"
                              v-model="form.is_bpjs_ketenagakerjaan_number"
                              :success="!!form.is_bpjs_ketenagakerjaan_number && valid"
                              :error-messages="errors"
                              required>
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Nomor Peserta {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                <div v-if="form.is_bpjs_ketenagakerjaan_number !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </div>
    
                        <div class="lainnya-field-block lainnya-nested ml-3">
                          <ValidationProvider
                            name="is_bpjs_ketenagakerjaan_note"
                            v-slot="{ errors, valid }">
                            <label class="lainnya-field-label">
                              Keterangan
                            </label>
                            <v-textarea
                              class="lainnya-input mt-1"
                              filled
                              rounded
                              dense
                              rows="3"
                              style="border-radius: 10px"
                              auto-grow
                              :color="set_color"
                              placeholder="Keterangan"
                              clearable
                              no-resize
                              hide-details
                              @click:clear="form.is_bpjs_ketenagakerjaan_note = ''"
                              v-uppercase
                              v-model="form.is_bpjs_ketenagakerjaan_note"
                              :success="!!form.is_bpjs_ketenagakerjaan_note && valid"
                              :error-messages="errors"
                              required>
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Keterangan {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                <div v-if="form.is_bpjs_ketenagakerjaan_note !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </div>
                      </template>
    
                      <div class="lainnya-field-block">
                        <ValidationProvider
                          name="is_bpjs_kesehatan"
                          rules="required"
                          v-slot="{ errors }">
                          <label class="lainnya-field-label">
                            b. Kesehatan
                          </label>
                          <v-radio-group
                            v-model="form.is_bpjs_kesehatan"
                            class="lainnya-radio-group mt-1"
                            row
                            hide-details
                            :error-messages="errors">
                            <v-radio
                              :color="set_color"
                              label="Ya"
                              :value="1"/>
                            <v-radio
                              :color="set_color"
                              label="Tidak"
                              :value="0"/>
                          </v-radio-group>
                        </ValidationProvider>
                      </div>
    
                      <template v-if="isYes(form.is_bpjs_kesehatan)">
                        <div class="lainnya-field-block lainnya-nested ml-3">
                          <ValidationProvider
                            name="is_bpjs_kesehatan_number"
                            rules="required"
                            v-slot="{ errors, valid }">
                            <label class="lainnya-field-label">
                              Nomor Peserta
                            </label>
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="lainnya-input mt-1"
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Nomor peserta"
                              clearable
                              type="text"
                              inputmode="numeric"
                              style="border-radius: 10px"
                              hide-details
                              @click:clear="form.is_bpjs_kesehatan_number = ''"
                              @keypress="onDigitsKeypress"
                              @input="form.is_bpjs_kesehatan_number = sanitizeDigitsOnly(form.is_bpjs_kesehatan_number)"
                              v-model="form.is_bpjs_kesehatan_number"
                              :success="!!form.is_bpjs_kesehatan_number && valid"
                              :error-messages="errors"
                              required>
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Nomor Peserta {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                <div v-if="form.is_bpjs_kesehatan_number !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </div>
    
                        <div class="lainnya-field-block lainnya-nested ml-3">
                          <ValidationProvider
                            name="is_bpjs_kesehatan_note"
                            rules="required"
                            v-slot="{ errors, valid }">
                            <label class="lainnya-field-label">
                              Keterangan
                            </label>
                            <v-textarea
                              class="lainnya-input mt-1"
                              filled
                              rounded
                              dense
                              rows="3"
                              auto-grow
                              :color="set_color"
                              placeholder="Keterangan"
                              clearable
                              no-resize
                              style="border-radius: 10px"
                              hide-details
                              @click:clear="form.is_bpjs_kesehatan_note = ''"
                              v-uppercase
                              v-model="form.is_bpjs_kesehatan_note"
                              :success="!!form.is_bpjs_kesehatan_note && valid"
                              :error-messages="errors"
                              required>
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Keterangan BPJS Kesehatan {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                <div v-if="form.is_bpjs_kesehatan_note !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </div>
                      </template>
                    </div>
                  </v-card> 

                  <v-card class="mb-4 pa-4" outlined>
                    <div class="lainnya-section-head mb-1">
                      Asuransi
                    </div>

                    <ValidationProvider 
                      name="bpjs_jenis" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Jenis BPJS
                        <!-- <span>
                          (boleh dikosongi)
                        </span> -->
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 45}%`"
                        class="mb-6"
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. Kelas 1"
                        hide-details
                        clearable
                        @click:clear="form.bpjs_jenis = ''"
      
                        v-uppercase
      
                        v-model="form.bpjs_jenis"
                        :success="valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jenis BPJS {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.bpjs_jenis !== '' && valid && form.bpjs_jenis !== null">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
      
                    <!-- <ValidationProvider 
                      name="job_other" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Pekerjaan Selain Abdi Dalem
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                        class="mb-6"
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. Manager F&B"
                        hide-details
      
                        v-uppercase
      
                        v-model="form.job_other"
                        :success="valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Pekerjaan Selain Abdi Dalem {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.job_other !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider> -->
      
                    <ValidationProvider 
                      name="asuransi_kes" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Memiliki Asuransi Kesehatan dan/atau Ketenagakerjaan
                        <!-- <span>
                          (boleh dikosongi)
                        </span> -->
                      </div>
      
                      <v-select
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                        class="mb-6"
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. YA"
                        hide-details
                        clearable
                        @click:clear="form.asuransi_kes = ''"
                        
                        :items="['YA', 'TIDAK', 'BELUM DIINPUT']"
                        item-text="text"
                        item-value="value"
                        :item-color="set_color"
      
                        v-model="form.asuransi_kes"
                        :success="form.asuransi_kes !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Memiliki Asuransi Kesehatan dan/atau Ketenagakerjaan {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.asuransi_kes !== '' && valid && form.asuransi_kes !== null">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-select>
                    </ValidationProvider>
      
                    <ValidationProvider 
                      name="nomor_polis_asuransi" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Nomor Polis Asuransi
                        <!-- <span>
                          (boleh dikosongi)
                        </span> -->
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 50}%`"
                        class="mb-6"
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 492010XXXXX"
                        hide-details
                        clearable
                        @click:clear="form.nomor_polis_asuransi = ''"
      
                        type="number"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        min="0"
      
                        v-uppercase
      
                        v-model="form.nomor_polis_asuransi"
                        :success="valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nomor Polis Asuransi {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.nomor_polis_asuransi !== '' && valid && form.nomor_polis_asuransi !== null">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
      
                    <ValidationProvider 
                      name="asuransi_status" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Status Asuransi
                        <!-- <span>
                          (boleh dikosongi)
                        </span> -->
                      </div>
      
                      <v-select
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                        class="mb-6"
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. MANDIRI"
                        hide-details
                        clearable
                        @click:clear="form.asuransi_status = ''"
                        
                        :items="['MANDIRI', 'PAKUALAMAN', 'BELUM DIINPUT']"
                        item-text="text"
                        item-value="value"
                        :item-color="set_color"
      
                        v-model="form.asuransi_status"
                        :success="form.asuransi_status !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Status Asuransi {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.asuransi_status !== '' && valid && form.asuransi_status !== null">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-select>
                    </ValidationProvider>
    
                    <!-- <ValidationProvider 
                      name="catatan_kesehatan" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Catatan Kesehatan
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>
                      
                      <v-textarea
                        v-on:keyup.enter="save"
                        style="border-radius: 10px;"
                        class="mb-6"
                        filled
                        rounded
                        dense
                        single-line
                        hide-details
      
                        rows="3"
      
                        :color="set_color"
                        placeholder="Contoh. Tuliskan catatan disini . . ."
                        
                        v-uppercase
      
                        v-model="form.catatan_kesehatan"
                        :success="form.catatan_kesehatan !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Catatan Kesehatan {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.catatan_kesehatan !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider> -->
                  </v-card> 
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>
      </ValidationObserver>

      <div>
        <v-divider 
          class="mb-4" 
          style="border: 3px solid #f0f0f0; border-radius: 50px;"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>

            Simpan
          </v-btn>

          <router-link
            to="/officer">
            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text px-2 ml-2"
              :disabled="process.form"
              style="border-radius: 10px;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>

              Batal
            </v-btn>
          </router-link>
        </v-card-actions>
      </div>
    </section>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          snackbar: false
        },
        picker: {
          tgl_awal_terima_danais: null,
          kop_join_date: null
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {

    },
    methods: {
      isYes (v) {
        return v === 1 || v === '1'
      },
      to01 (v) {
        return (v === 1 || v === '1') ? 1 : 0
      },
      sanitizeDigitsOnly (val) {
        if (val === null || val === undefined) return ''
        return String(val).replace(/\D/g, '')
      },
      onDigitsKeypress (e) {
        const code = e.charCode != null ? e.charCode : e.keyCode
        if (!code) return true
        return code >= 48 && code <= 57
      },
      async save () {
        this.message.error = ''
        this.form.mobilephone = this.form.mobilephone.replace(/^0/, '').replace(/^62/, '')
        this.form.wa_number = this.form.wa_number.replace(/^0/, '').replace(/^62/, '')
        this.form.emergency_number = this.form.emergency_number.replace(/^0/, '').replace(/^62/, '')
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form)
          forms.is_terima_danais = this.to01(forms.is_terima_danais)
          forms.is_anggota_koperasi = this.to01(forms.is_anggota_koperasi)
          forms.is_bpjs_ketenagakerjaan = this.to01(forms.is_bpjs_ketenagakerjaan)
          forms.is_bpjs_kesehatan = this.to01(forms.is_bpjs_kesehatan)
          forms.seksi = JSON.stringify(forms.seksi)
          forms.mobilephone =  this.form.mobilephone !== '' && this.form.mobilephone !== null ? '62' + this.form.mobilephone : this.form.mobilephone
          forms.wa_number =  this.form.wa_number !== '' && this.form.wa_number !== null ? '62' + this.form.wa_number : this.form.wa_number
          forms.emergency_number =  this.form.emergency_number !== '' && this.form.emergency_number !== null ? '62' + this.form.emergency_number : this.form.emergency_number
          
          await post(`admin/user/update`, {
            data: forms
          })
          .then((response) => {
            let res = response.data

            if (res.status === 200) {
              this.$emit('load', true)
                
              this.process.form = false

              this.dialog.snackbar = true
              this.message.success = res.message
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style scoped>
  .lainnya-page-row {
    min-height: 64.6vh;
  }

  .lainnya-card {
    border-radius: 16px !important;
    border-color: rgba(0, 0, 0, 0.08) !important;
    /* background: #fafbfc; */
  }

  .lainnya-card__title {
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: rgba(0, 0, 0, 0.87);
    line-height: 1.3;
  }

  .lainnya-card__subtitle {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.55);
    font-weight: 400;
  }

  .lainnya-card__body {
    padding-top: 8px !important;
  }

  .lainnya-field-label {
    display: block;
    font-size: 0.875rem;
    /* font-weight: 600; */
    color: rgba(0, 0, 0, 0.65);
    letter-spacing: 0.01em;
  }

  .lainnya-field-block {
    margin-bottom: 1.35rem;
  }

  .lainnya-field-block:last-child {
    margin-bottom: 0;
  }

  .lainnya-nested {
    padding-left: 0.5rem;
    border-left: 3px solid rgba(0, 0, 0, 0.08);
    margin-left: 0.15rem;
  }

  @media (min-width: 600px) {
    .lainnya-nested {
      padding-left: 1rem;
      margin-left: 0.25rem;
    }
  }

  .lainnya-card .v-card {
    border-radius: 12px;
    border: 1px solid rgba(0,0,0,0.08);
  }

  .lainnya-section-head {
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(0,0,0,0.75);
  }

  .lainnya-radio-group >>> .v-input--selection-controls__input {
    margin-right: 2px;
  }

  .lainnya-radio-group >>> .v-radio {
    margin-right: 16px;
  }

  /* .lainnya-input >>> .v-input__slot {
    background: #fff !important;
  } */
</style>